import React, { useState } from 'react';
import {Link} from "react-router-dom";
import firebase from "firebase/app";
import apis from "../assets/js/apis.js";
import axios from '../models/node_modules/axios';

const NO_PIC_URL = 1;
const EMAIL_NOT_CORRECT = 2;
const PASSWORD_MISMATCH = 3;
const FIELD_EMPTY = 4;
const FIREBASE_AUTH_FAILED = 5;
const SERVER_ERROR = 6;
const CLIENT_ERROR = 7;
const SHOW_PIC = 8;


export default function SignUp() {

  const [uploaded,setuploaded] = useState(false);
  const [em,setEM] = useState("");
  const [pa,setPA] = useState("");
  const [pu,setPU] = useState("");
  const [na,setNA] = useState("");
  const [file,setFile]=useState(null);




  function apply(file){
    var src = window.URL.createObjectURL(file);
    setFile(src);
    setuploaded(true);
  };



  return (
    <div>
          <div class="w-full">
          <div class="my-6 flex w-full"><div class="m-auto font-bold text-lg"><div>horsey</div><div class="text-xs ">beta</div> </div></div>
              <div>
              {uploaded?
              <div class="h-20 w-20 border-2 text-xs text-center border-blue-700 rounded-full overflow-hidden">
                <img src={file} height="100px" width="100px"></img>
              </div>:
              <div class="h-20 w-20 border-2 text-xs text-center border-blue-700 rounded-full"></div>}
              <form>
                <div class="flex mt-6"><div class="m-auto w-10/12">Name</div></div>
                <div class="flex mb-6 w-full"><input type="text" class=" rounded-2xl border-2 border-black m-auto w-10/12 h-12 p-2"/></div>
                <div class="flex mt-6"><div class="m-auto w-10/12">Email</div></div>
                <div class="flex mb-6 w-full"><input type="email" class=" rounded-2xl border-2 border-black m-auto w-10/12 h-12 p-2"/></div>
                <div><div class="m-auto w-10/12">New Password</div></div>
                <div class="flex mb-2 w-full"><input type="text" class=" rounded-2xl border-2 border-black m-auto w-10/12 h-12 p-2"/></div>
                <div><div class="m-auto w-10/12">Confirm Password</div></div>
                <div class="flex mb-2 w-full"><input type="password" class=" rounded-2xl border-2 border-black m-auto w-10/12 h-12 p-2"/></div>
                {true&&<div class="mb-6"></div>}
                <div class="flex w-full my-4"><button class="py-2 px-4 rounded-xl bg-blue-700 text-white m-auto">
                  Sign Up
                </button>
                </div>
              </form>
              
          </div>
              <div class="px-8 text-center "><Link to="/signIn">
                {"Already have an account? Sign in"}
              </Link>
              </div>
          </div>
          <div class="h-16"></div>
    </div>
  );
}



// function signUpFunc(){
//   let obj = {
//     "email":em,
//     "password":pa,
//     "pic_url":"",
//     "name":na,
//   }
//   firebase.auth().createUserWithEmailAndPassword(em, pa)
//   .then((userCredential) => {
//     var user = userCredential.user;
//     return axios.post(apis.newuser,obj)
//   }).then(response=>{
//     if(response.data.success==1){
//     localStorage.setItem('creds',JSON.stringify({
//       "email": em,
//       "password": pa
//     }))}
//     var storageRef = firebase.storage().ref();
//     var imageRef = storageRef.child(`user${em}.jpg`);
//     var userImagesRef = storageRef.child('images/user${em}.jpg');
//     storageRef.put(file).then((snapshot) => {
//       history.push("/paymentPage");
//     });
//   })
//   .catch((error) => {
//     var errorCode = error.code;
//     var errorMessage = error.message;
//   });

// }


// <AvatarImageCropper apply={apply.bind(this)}/>